import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            探索开运世界
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大开运分类，全方位提升您的好运气
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200/70 p-6 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative z-10">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {cat.description}
                </p>
                <div className="mt-4 flex items-center gap-1 text-sm text-primary-500 font-medium">
                  <span>了解更多</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}